import React from 'react';
import { Col, FormControl, HelpBlock, Row, Well } from 'react-bootstrap';
import FieldGroup from '../../../components/FieldGroup';
import Datetime from 'react-datetime';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import { ABNORMALITIES, I18N } from '../../../constants';
import { formatStopLocation } from '../../../shared/utils/run';

const GENERIC_ABNORMALITIES = [
    ABNORMALITIES.DAMAGE,
    ABNORMALITIES.EARLY_FREIGHT,
    ABNORMALITIES.LATE_FREIGHT,
    ABNORMALITIES.INTERNAL_LOGISTICS,
    ABNORMALITIES.NEW_ORDER,
    ABNORMALITIES.RETURN_FREIGHT,
    ABNORMALITIES.SHORT_SHIPMENT,
    ABNORMALITIES.UNABLE_TO_LOCATE,
    ABNORMALITIES.PARTIAL_SHORT_SHIPMENT,
];

const GenericInfo = ({ abnormality, stops, form, errors, handleDateChange, handleInputChange }) => (
    <Well>
        <Row>
            <Col sm={6}>
                <Row>
                    <Col sm={4} style={{ marginTop: 10 }}>
                        <label className="control-label">Abnormality Type *</label>
                    </Col>
                    <Col sm={8} style={{ marginTop: 5 }}>
                        <FormControl
                            name="abnormalityType"
                            value={form.abnormalityType}
                            onChange={handleInputChange}
                            componentClass="select"
                        >
                            <option value="" disabled>
                                Select a type
                            </option>
                            {GENERIC_ABNORMALITIES.map(type => (
                                <option key={type} value={type}>
                                    {I18N.ABNORMALITIES[type]}
                                </option>
                            ))}
                        </FormControl>
                        {errors.abnormalityType && (
                            <HelpBlock>
                                <span className="text-danger">{errors.abnormalityType}</span>
                            </HelpBlock>
                        )}
                    </Col>
                </Row>
            </Col>
            <Col sm={6}>
                <Row>
                    <Col sm={4} style={{ marginTop: 10 }}>
                        <label className="control-label">Abnormality Date *</label>
                    </Col>
                    <Col sm={8} style={{ marginTop: 5 }}>

                    {(abnormality && abnormality.abnormalityDate) ? 
                        (
                            <p style={{ marginTop: 5 }}> {moment(abnormality.abnormalityDate).format("YYYY-MM-DD HH:mm")}
                            </p> // if it's not editable then take the string of the moment date
                        ) : (
                            
                            <div>

                            <Datetime
                                value={form.abnormalityDate}
                                onChange={handleDateChange('abnormalityDate')}
                                dateFormat="DD-MM-YYYY"
                                timeFormat="HH:mm"
                                inputProps={{ maxLength: 255 }}
                                className={errors.abnormalityDate && 'datetime-error'}
                            />
                                {errors.abnormalityDate && (
                                    <p style={{ color: '#CF142B', marginTop: 5 }}>
                                        {errors.abnormalityDate}
                                    </p>
                                )}
                            </div>)
                        }
                    </Col>
                </Row>
            </Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
            <Col sm={6}>
                <Row>
                    <Col sm={4} style={{ marginTop: 10 }}>
                        <label className="control-label">Abnormality Status</label>
                    </Col>
                    <Col sm={8} style={{ marginTop: 5 }}>
                        <p style={{ marginTop: 5, fontWeight: 'bold' }}>
                            {abnormality.abnormalityStatus
                                ? I18N.ABNORMALITY_STATUS[abnormality.abnormalityStatus]
                                : '-'}
                        </p>
                    </Col>
                </Row>
            </Col>
            <Col sm={6}>
                <Row>
                    <Col sm={4} style={{ marginTop: 10 }}>
                        <label className="control-label">Abnormality Location *</label>
                    </Col>
                    <Col sm={8} style={{ marginTop: 5 }}>
                        <FormControl
                            name="abnormalityLocation"
                            value={form.abnormalityLocation}
                            onChange={handleInputChange}
                            componentClass="select"
                        >
                            <option value="" disabled>
                                Select a location
                            </option>
                            {stops.map(
                                stop =>
                                    !isEmpty(stop) && (
                                        <option key={stop.stopId} value={stop.stopId}>
                                            {formatStopLocation(stop)}
                                        </option>
                                    )
                            )}
                            <option value={I18N.ABNORMALITY_LOCATION.OTHER}>
                                {I18N.ABNORMALITY_LOCATION.OTHER}
                            </option>
                        </FormControl>
                        {errors.abnormalityLocation && (
                            <HelpBlock>
                                <span className="text-danger">{errors.abnormalityLocation}</span>
                            </HelpBlock>
                        )}
                    </Col>
                </Row>
            </Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
            <Col sm={6} />

            <Col sm={6}>
                <FieldGroup
                    id="trailerIdentifier"
                    label="Trailer Number"
                    value={form.trailerIdentifier}
                    onChange={handleInputChange}
                    errorMessage=""
                    horizontal
                />
            </Col>
        </Row>
    </Well>
);

export default GenericInfo;
